import {setLayersLoading_actionType} from "../constants";
const initialState = false;

const layersLoading = (state = initialState, action) => {
  const { type, payload } = action;
  
  switch (type) {
    case setLayersLoading_actionType:
      return state = payload;
    default:
      return state;
  }
};

export default layersLoading;